var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "offeringOptionsView" },
    [
      _vm._l(_vm.selectOptions, function (selectOption) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: selectOption.show,
                expression: "selectOption.show",
              },
            ],
            key: selectOption.id,
            staticClass: "tr",
          },
          [
            _c("div", { staticClass: "td" }, [
              _c("label", [
                _vm._v("\n\t\t\t\t" + _vm._s(selectOption.label) + "\n\t\t\t"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "td" }, [
              _c(
                "select",
                {
                  staticClass: "selectBox",
                  attrs: { id: selectOption.id, name: selectOption.name },
                  domProps: { value: selectOption.valueModel.id },
                  on: { input: _vm.selectedOptionOutput },
                },
                _vm._l(selectOption.valueModels, function (selectValueModel) {
                  return _c(
                    "option",
                    {
                      key: selectValueModel.id,
                      domProps: { value: selectValueModel.id },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.getOptionLabel(selectValueModel)) +
                          "\n\t\t\t\t"
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        )
      }),
      _vm._v(" "),
      _vm.showPricing && _vm.isAvailableInRegion
        ? _c("div", { staticClass: "tr priceRow" }, [
            _c("div", { staticClass: "td" }, [
              _vm._v("\n\t\t\t" + _vm._s(_vm.$t("price")) + "\n\t\t"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "td productPrice" },
              [
                _c("PriceView", {
                  attrs: { cents: _vm.selectedOfferingPrice },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }